import { render, staticRenderFns } from "./InfoPedido.vue?vue&type=template&id=11bc271b&scoped=true&"
import script from "./InfoPedido.vue?vue&type=script&lang=js&"
export * from "./InfoPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bc271b",
  null
  
)

export default component.exports